import { Container } from 'react-bootstrap';
import "./Skip2Submit.css";

const Skip2Submit = (props) => {

  return(
    <div id="submission-card-wrapper">
      <Container fluid id="submission-card">
        <div id="submission-card-items">
          <div id="submission-card-header">
          </div>
          <div id="submission-card-btn-section">
            <div id="submission-card-button">
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default Skip2Submit;